import { TGetStateResponseCompanyDE } from '../../../lapiOverrideTypesDE';
import {
  LOAN_DURATION_OPTIONS_DE,
  LOAN_PURPOSE_OPTIONS_DE,
} from '../../GetStarted/GetStartedDE/loanOptions';

export type TPersonTitleDE = 'herr' | 'frau';

export type TMobileSignupForm = {
  // Get started → application object (requested_products[0]) + emails on state
  amount: string;
  loanDuration: (typeof LOAN_DURATION_OPTIONS_DE)[number]['value'] | '';
  loanPurpose: (typeof LOAN_PURPOSE_OPTIONS_DE)[number]['value'] | '';
  loanPurposeDetails?: string;
  email: string;

  // Business details → state.application.company
  companyName: string;
  crefoId?: string;
  legalForm?: TGetStateResponseCompanyDE['type'];
  buildingNumber: string;
  street: string;
  postcode: string;
  town: string;
  startDateMonth: string;
  startDateYear: string;
  last12MonthsTurnover: string;

  // Personal details → state.application.people[0]
  title?: TPersonTitleDE;
  firstName: string;
  lastName: string;
  dobDay: string;
  dobMonth: string;
  dobYear: string;
  phoneNumber: string;
  privacyPolicyAgreement: boolean;

  // Home address → state.application.people[0].residential_addresses[0].
  // uid minting on PUT is handled by denormalisePersonalDataDE.
  homeStreet: string;
  homeHouseNumber: string;
  homePostcode: string;
  homeTown: string;
};

export const EMPTY_FORM: TMobileSignupForm = {
  amount: '',
  loanDuration: '',
  loanPurpose: '',
  loanPurposeDetails: '',
  email: '',
  companyName: '',
  crefoId: '',
  legalForm: undefined,
  buildingNumber: '',
  street: '',
  postcode: '',
  town: '',
  startDateMonth: '',
  startDateYear: '',
  last12MonthsTurnover: '',
  title: undefined,
  firstName: '',
  lastName: '',
  dobDay: '',
  dobMonth: '',
  dobYear: '',
  phoneNumber: '',
  privacyPolicyAgreement: false,
  homeStreet: '',
  homeHouseNumber: '',
  homePostcode: '',
  homeTown: '',
};
